import styled from 'styled-components'

import { textStyles } from '../../theme'
import ActionButton from '../../components/ActionButton'

export const Content = styled.div`
  padding: 4rem 2rem;
  flex-grow: 1;
`

export const Box = styled.div`
  max-width: 640px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`

export const Title = styled.h1`
  ${textStyles.titleH1};
  text-align: center;
`
export const Forms = styled.div`
  margin-top: 4rem;
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4rem;
`

export const NewAppointementButton = styled(ActionButton)`
  margin-top: 6rem;
  min-width: max-content;
  width: max-content;
  align-self: center;
`
